export default __webpack_public_path__ + "static/media/Icons_Menu_Close_Bold.c1e1567a.svg";